import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { fetchClients } from '../../../../pages/ClientsPage'
import { modalActions, ModalTypes } from '../../../../entities/Modal'

export const deleteClient = createAsyncThunk<
	void,
	string,
	ThunkConfig<string>
>(
	'deleteClient',
	async (clientId, thunkAPI) => {

		const { dispatch, extra: { api }, rejectWithValue } = thunkAPI

		try {
			await api.delete(`/clients/${clientId}`)

			showToast({
				type: 'success',
				toastId: 'deleteClient',
				message: 'Success'
			})

			dispatch(fetchClients()) // imported from pages
		} catch (e: any) {
			console.log(e)
			if (e?.response.status === 409) {
				dispatch(modalActions.showModal({
					modalType: ModalTypes.SHOW_409_MODAL,
					data: e?.response.data.message
				}))
			} else {
				appHandleError(e, 'deleteClient', 'Failed to delete client')
			}
			return rejectWithValue('Error occurred on client delete')
		}
	})